import React from 'react';
import ReactDOM from 'react-dom';
import App from '@ui/App';
import 'leaflet';
import * as L from "leaflet";
import "leaflet-draw";
import 'leaflet/dist/leaflet.css';
import "leaflet-draw/dist/leaflet.draw.css";
import 'leaflet-polylinedecorator';
import 'react-leaflet-markercluster/dist/styles.min.css';
import '@scss/index.scss';

const rootElement = document.getElementById('root');
ReactDOM.render(<App />, rootElement);
